// extracted by mini-css-extract-plugin
export default {"SupportContentFooter__wrapper":"Xhuh1JVFyu","SupportContentFooter__PrivacyPolicyFontWeight":"cViY_nqfWQ"};